/**
 * Dados mock da aba "Transição Anual" — cronograma de implementação da
 * LC 214/2025 (CBS/IBS) sobreposto à evolução real da carga tributária da
 * empresa (mesma série `evolucaoCarga` usada no Dashboard).
 */

export const marcosLegais = [
  {
    ano: 2026,
    fase: "Teste",
    titulo: "CBS e IBS entram em vigor (alíquota teste)",
    descricao: "Alíquota de teste de 0,1%, compensável com os tributos atuais. Sem impacto real de caixa — período de calibração dos sistemas.",
  },
  {
    ano: 2027,
    fase: "CBS Plena",
    titulo: "PIS/COFINS são extintos",
    descricao: "CBS passa a vigorar em alíquota cheia, substituindo definitivamente PIS/COFINS. O IBS segue em fase de teste.",
  },
  {
    ano: 2028,
    fase: "Consolidação",
    titulo: "Manutenção do modelo de 2027",
    descricao: "Período de ajuste de sistemas, precificação e apuração de créditos antes do início da transição do IBS.",
  },
  {
    ano: 2029,
    fase: "Início da Transição",
    titulo: "ICMS/ISS começam a ceder espaço ao IBS",
    descricao: "O IBS passa a responder por uma parcela crescente da carga, com redução proporcional de ICMS e ISS.",
  },
  {
    ano: 2030,
    fase: "Ano de Virada",
    titulo: "Regime futuro ultrapassa o vigente",
    descricao: "Pela primeira vez, CBS+IBS respondem pela maior parte da carga tributária total da empresa.",
    destaque: true,
  },
  {
    ano: 2031,
    fase: "Aceleração",
    titulo: "Redução acentuada de ICMS/ISS",
    descricao: "A fatia do regime vigente cai rapidamente à medida que o IBS assume a maior parte da arrecadação.",
  },
  {
    ano: 2032,
    fase: "Fase Final",
    titulo: "ICMS e ISS quase extintos",
    descricao: "Regime vigente já residual — praticamente toda a carga tributária já opera sob CBS+IBS.",
  },
  {
    ano: 2033,
    fase: "Regime Pleno",
    titulo: "Transição concluída",
    descricao: "CBS e IBS totalmente implementados; PIS, COFINS, ICMS e ISS deixam de existir para a empresa.",
  },
];
